import React, { ReactNode, useMemo } from 'react'
import tw from 'twin.macro'
import { Modal } from '@mui/material'
import { ChevronLeftMinor } from '@shopify/polaris-icons'
import { Button } from './shared/Button'

interface Props {
  isOpen?: boolean
  content: ReactNode
  onSubmit(): void
  onClose(): void
}

export const SignContractAgreementModal = ({ isOpen, content, onSubmit, onClose }: Props) => {
  const container = useMemo(() => document.getElementById('root'), [])

  return (
    <Modal
      container={container}
      open={Boolean(isOpen)}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      css={tw`w-full h-full flex flex-col justify-center backdrop-blur`}
    >
      <div css={tw`w-full max-h-full m-auto overflow-auto p-4`}>
        <div css={tw`max-w-[390px] m-auto flex-col p-4 pt-6 bg-shades-0 rounded-2xl`}>
          <div css={tw`h-full w-full flex flex-col`}>
            <Button
              color="grey"
              leftIcon={<ChevronLeftMinor width={20} />}
              onClick={onClose}
              data-testid="contractors-onboarding-sign-contract-agreement-back-btn"
            >
              Back
            </Button>
            {content}
            <Button
              className={tw`w-full`}
              onClick={onSubmit}
              data-testid="contractors-onboarding-sign-contract-agreement-continue-btn"
            >
              Agree and continue
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
